import type { Store } from "@/types/content";

export const storesPart1: Store[] = [
  {
    id: "svc-1",
    slug: "taipei-spa-luxury",
    name: "舒壓秘境 SPA",
    description: "位於台北東區黃金地段巷弄內的精品按摩會館，提供指壓、油壓、芳療、熱石等多種專業療程。全館採用獨立包廂設計，確保每位客人的隱私與寧靜。環境以溫暖木質調搭配柔和燈光，進門就能感受到與外界喧囂截然不同的放鬆氛圍。所有師傅皆持有專業證照，是東區上班族週末舒壓的首選去處。",
    coverImage: "https://readdy.ai/api/search-image?query=Luxury%20spa%20treatment%20room%20with%20warm%20amber%20lighting%20candles%20and%20flower%20petals%20massage%20table%20zen%20interior%20professional%20wellness%20photography%20clean%20neutral%20background&width=1200&height=630&seq=401&orientation=landscape",
    category: "按摩",
    tags: ["SPA", "指壓", "油壓", "芳療", "東區", "大安區"],
    priceRange: "$1,200 - $3,500",
    location: "台北市大安區忠孝東路四段 123 號 2F",
    rating: 4.8,
    reviewCount: 256,
    features: ["獨立包廂", "淋浴設施", "免費茶點", "情侶雙人房", "線上預約"],
    content: [
      {
        _type: "richText",
        _key: "intro",
        content: "<p>舒壓秘境 SPA 位於台北東區巷弄內，是一間專為都會男女打造的精品按摩會館。從一踏入大門就能感受到與外界喧囂截然不同的寧靜氛圍——柔和的音樂、淡淡的精油香氣、以及親切卻不過度打擾的接待。</p><p>這次神秘客體驗了 90 分鐘深層油壓療程，從迎賓花茶到療程後的手工餅乾，每個細節都感受到店家的用心。</p>",
      },
      {
        _type: "featureList",
        _key: "features",
        title: "評比發現",
        features: [
          { _key: "f1", icon: "ri-door-closed-line", title: "獨立包廂 ✓", description: "每間療程室皆為獨立空間，確保隱私，情侶雙人房也有專屬配置" },
          { _key: "f2", icon: "ri-showers-line", title: "淋浴設施 ✓", description: "療程前後皆可使用高級淋浴設備，備有品牌沐浴用品" },
          { _key: "f3", icon: "ri-cup-line", title: "免費茶點 ✓", description: "提供季節花茶與手工餅乾，療程後的小確幸" },
          { _key: "f4", icon: "ri-user-star-line", title: "師傅均持有證照 ✓", description: "所有師傅皆持國家乙級按摩證照，定期進修培訓" },
        ],
      },
      {
        _type: "testimonial",
        _key: "reviews",
        title: "探店心得",
        testimonials: [
          { _key: "r1", quote: "神秘客探訪：深層油壓 90 分鐘，師傅手法細膩，力道溝通良好。包廂隱密舒適，療程後的茶點是加分項。整體評價：推薦。", author: "Amy 編", role: "神秘客評比員" },
          { _key: "r2", quote: "情侶雙人房體驗：兩個包廂相連但各自獨立，不會互相干擾。療程同步進行後的交流時間讓整體體驗更完整。", author: "神秘客 B", role: "神秘客評比員" },
        ],
      },
      {
        _type: "faq",
        _key: "faq",
        title: "常見問題",
        items: [
          { _key: "q1", question: "需要提前多久預約？", answer: "建議至少提前 3-5 天預約，週末時段較熱門，建議提前一週。" },
          { _key: "q2", question: "可以指定師傅嗎？", answer: "可以，預約時備註喜好的師傅即可。若該師傅當日休診，我們會另行通知。" },
          { _key: "q3", question: "生理期可以按摩嗎？", answer: "輕度按摩是可以的，但建議避開腰腹部。預約時告知師傅，會調整療程內容。" },
        ],
      },
      {
        _type: "cta",
        _key: "cta",
        title: "查看完整評比報告",
        subtitle: "美好時光指南神秘客公正評比，帶你了解這間店的真實水準",
        buttonLabel: "查看店家詳情",
        buttonHref: "#",
      },
    ],
    seo: {
      title: "舒壓秘境 SPA｜台北東區精品按摩評比",
      description: "台北東區精品按摩評比！神秘客實測獨立包廂 SPA，指壓油壓芳療齊全。4.8 星 256 則評價。",
      keywords: ["台北按摩", "東區SPA", "按摩推薦", "情侶按摩"],
    },
  },
  {
    id: "svc-2",
    slug: "taipei-hair-salon-premium",
    name: "光感美髮沙龍",
    description: "位於台北中山區的質感美髮沙龍，以天然植物染和日系設計剪法為特色。設計師皆有 5 年以上資歷，部分曾赴日本研修。提供完整的頭皮保養服務，從洗髮到染燙後護理一條龍。沙龍空間寬敞明亮，每個造型台之間保持足夠間距，提供舒適無壓力的美髮體驗。",
    coverImage: "https://readdy.ai/api/search-image?query=Modern%20upscale%20hair%20salon%20interior%20with%20professional%20styling%20stations%20and%20mirrors%20natural%20lighting%20stylists%20working%20sophisticated%20atmosphere%20simple%20background%20photography&width=1200&height=630&seq=402&orientation=landscape",
    category: "美髮",
    tags: ["美髮", "植物染", "日系剪髮", "頭皮護理", "中山區"],
    priceRange: "$800 - $5,000",
    location: "台北市中山區南京東路二段 150 號 4F",
    rating: 4.7,
    reviewCount: 312,
    features: ["植物染", "日系設計", "頭皮護理", "無推銷", "染後護理"],
    content: [
      {
        _type: "richText",
        _key: "intro",
        content: "<p>光感美髮沙龍以天然植物染聞名，是對髮質要求高且不想用化學染劑的人的好選擇。沙龍的設計師平均資歷超過 5 年，不少人曾赴日本研修，帶回紮實的剪髮技術。</p>",
      },
      {
        _type: "featureList",
        _key: "features",
        title: "評比發現",
        features: [
          { _key: "f1", icon: "ri-leaf-line", title: "植物染技術 ✓", description: "使用歐洲進口植物染，降低頭皮刺激，適合敏感頭皮或孕婦" },
          { _key: "f2", icon: "ri-scissors-line", title: "溝通充分 ✓", description: "設計師上工前花 15-20 分鐘確認需求，不擅自決定造型方向" },
          { _key: "f3", icon: "ri-checkbox-circle-line", title: "無推銷壓力 ✓", description: "結帳時不強推護髮品或加購課程，只有在你詢問時才提供建議" },
        ],
      },
      {
        _type: "cta",
        _key: "cta",
        title: "查看完整美髮評比",
        subtitle: "神秘客公正評比台北美髮沙龍，幫你找到最適合的設計師",
        buttonLabel: "查看店家詳情",
        buttonHref: "#",
      },
    ],
    seo: {
      title: "光感美髮沙龍｜台北中山區植物染日系美髮評比",
      description: "台北中山區植物染美髮評比！日系剪法設計師坐鎮，頭皮護理齊全。4.7 星 312 則評價。",
      keywords: ["台北美髮", "植物染", "中山區美髮", "日系剪髮"],
    },
  },
  {
    id: "svc-3",
    slug: "taipei-nail-studio",
    name: "SAKURA 日式美甲工作室",
    description: "台北中山區的日式美甲名店，設計師均赴日受訓，以手繪藝術甲和精緻日系光療著稱。使用日本進口凝膠，顏色純正、持久度高。工作室採預約制，確保每位客人都能獲得充分的服務時間。空間設計溫馨日系風，等候區提供茶飲服務。",
    coverImage: "https://readdy.ai/api/search-image?query=Japanese%20nail%20art%20studio%20elegant%20workstation%20with%20delicate%20floral%20designs%20nail%20polish%20bottles%20warm%20lighting%20clean%20simple%20background%20photography%20professional%20nail%20technician&width=1200&height=630&seq=403&orientation=landscape",
    category: "美甲",
    tags: ["美甲", "日系", "手繪", "光療", "中山區"],
    priceRange: "$800 - $2,500",
    location: "台北市中山區中山北路二段 120 號 3F",
    rating: 4.9,
    reviewCount: 445,
    features: ["日本進口膠", "手繪藝術", "高持久度", "預約制", "免費茶飲"],
    content: [
      {
        _type: "richText",
        _key: "intro",
        content: "<p>SAKURA 日式美甲工作室是台北少數堅持由赴日受訓設計師操刀的美甲店。每位師傅都有日本 JNAフォーミュラ 認定資格，技術有國際標準背書。</p><p>這次神秘客體驗了手繪花卉設計款，整個過程約 2.5 小時，師傅在每個細節上都不馬虎——底層的強化、顏色的鋪陳、到最後的封層打磨，每個步驟都做到位。</p>",
      },
      {
        _type: "featureList",
        _key: "features",
        title: "評比發現",
        features: [
          { _key: "f1", icon: "ri-paint-brush-line", title: "手繪細節精緻 ✓", description: "手繪設計每筆都紮實，不用貼紙替代，是真正的手工藝術" },
          { _key: "f2", icon: "ri-timer-line", title: "持久度高 ✓", description: "神秘客 2 週後回訪確認，幾乎無翹邊，顏色飽和度保持良好" },
          { _key: "f3", icon: "ri-customer-service-line", title: "設計溝通充分 ✓", description: "上工前會先畫小樣確認設計方向，不會直接就動手" },
        ],
      },
      {
        _type: "cta",
        _key: "cta",
        title: "查看完整美甲評比",
        subtitle: "神秘客公正評比台北美甲工作室，找到做工最精緻的選擇",
        buttonLabel: "查看店家詳情",
        buttonHref: "#",
      },
    ],
    seo: {
      title: "SAKURA 日式美甲工作室｜台北中山區美甲評比",
      description: "台北中山區日式美甲評比！赴日受訓設計師，手繪藝術甲持久度高。4.9 星 445 則評價。",
      keywords: ["台北美甲", "日式美甲", "中山區美甲", "美甲推薦"],
    },
  },
  {
    id: "svc-4",
    slug: "taipei-lash-studio",
    name: "LUMI 美睫工作室",
    description: "專注美睫服務的精品工作室，以自然感嫁接見長。師傅均持有韓國美睫認證，擅長依照客人的眼型設計最適合的睫毛款式。工作室環境安靜舒適，採預約制。使用低刺激醫美級膠水，敏感膚質也能安心。提供嫁接後 1 週免費補睫服務。",
    coverImage: "https://readdy.ai/api/search-image?query=Professional%20eyelash%20extension%20studio%20with%20magnifying%20beauty%20lamp%20comfortable%20treatment%20chair%20clean%20white%20interior%20soft%20lighting%20simple%20background%20photography%20beauty%20salon%20atmosphere&width=1200&height=630&seq=404&orientation=landscape",
    category: "美睫",
    tags: ["美睫", "睫毛嫁接", "韓式", "自然感", "預約制"],
    priceRange: "$1,200 - $3,000",
    location: "台北市大安區復興南路一段 210 號 5F",
    rating: 4.8,
    reviewCount: 289,
    features: ["韓國認證師傅", "醫美級膠水", "1週免費補睫", "眼型設計", "低過敏"],
    content: [
      {
        _type: "richText",
        _key: "intro",
        content: "<p>LUMI 美睫工作室以「自然感嫁接」為品牌核心，在一片強調濃密厚重的美睫市場中走出了自己的路。這裡的師傅會花時間了解你的眼型、生活習慣（是否常游泳、是否常化眼妝），再設計最合適的款式。</p>",
      },
      {
        _type: "featureList",
        _key: "features",
        title: "評比發現",
        features: [
          { _key: "f1", icon: "ri-eye-line", title: "自然度高 ✓", description: "嫁接後睫毛看起來像是本來就這麼長，不誇張不假睫毛感" },
          { _key: "f2", icon: "ri-shield-check-line", title: "低過敏膠水 ✓", description: "使用醫美級低刺激膠水，神秘客測試無過敏反應" },
          { _key: "f3", icon: "ri-calendar-check-line", title: "售後服務完善 ✓", description: "嫁接後 7 天內如有提前脫落或不均，可免費回補" },
        ],
      },
      {
        _type: "cta",
        _key: "cta",
        title: "查看完整美睫評比",
        subtitle: "神秘客公正評比台北美睫工作室，找到最自然的嫁接選擇",
        buttonLabel: "查看店家詳情",
        buttonHref: "#",
      },
    ],
    seo: {
      title: "LUMI 美睫工作室｜台北大安區美睫評比",
      description: "台北大安區美睫評比！韓國認證師傅，自然感嫁接，低過敏膠水。4.8 星 289 則評價。",
      keywords: ["台北美睫", "美睫推薦", "睫毛嫁接", "自然美睫"],
    },
  },
];